module.exports = __webpack_public_path__ + "img/1.23aaa343.png";